var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncidentio = function SvgIncidentio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 128 163"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#incidentio_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F25533",
    fillRule: "evenodd",
    d: "M48.734 139.642V163C20.759 156.323 0 131.711 0 102.372 0 85.456 7.158 72.035 18.105 58.87 27.183 47.953 49.6 19.043 56.655 3.09c1.712-3.873 6.08-3.724 7.963-1.643 6.025 6.657 13.451 21.196 15.88 37.688.495 3.36.699 6.104.86 8.283.348 4.677.502 6.757 2.927 6.757 3.81 0 6.303-5.777 6.85-11.74.352-3.821 4.142-5.1 6.756-3.821 12.572 6.15 25.401 35.429 28.502 49.796.973 4.506 1.607 9.162 1.607 13.962 0 29.274-20.665 53.842-48.546 60.583v-23.313zM64 130.333c9.832 0 17.802-7.544 17.802-16.85 0-14.842-10.944-25.449-16.397-28.672-.369-.218-.553-.327-1.054-.314-.367.01-.908.24-1.17.496-.358.351-.453.75-.642 1.548-.967 4.066-4.01 6.964-7.212 10.015-4.413 4.204-9.128 8.696-9.128 16.927 0 9.306 7.97 16.85 17.801 16.85",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "incidentio_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h128v163H0z"
  })))));
};
export default SvgIncidentio;